/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

export interface VideoTextTemplate {
  updatedAt: string
  createdAt: string
  videoText: string
  name: string
  tenantId: Cuid
  id: Cuid
}
